import { initHeaderAttribution } from './modules/header-attribution.js';
import { initQr } from './modules/get-the-app/qr.js';
import { initLinkActions } from './modules/get-the-app/link-actions.js';
import { initShortLink } from './modules/get-the-app/short-link.js';

function hasGetAppSurface() {
  return Boolean(
    document.querySelector('#qr-container') ||
      document.querySelector('#link-actions') ||
      document.querySelector('a.js-af-cta') ||
      document.querySelector('#copy-url')
  );
}

async function boot() {
  initHeaderAttribution();

  if (!hasGetAppSurface()) return;

  if (document.querySelector('#qr-container')) initQr();
  if (document.querySelector('#link-actions')) initLinkActions();

  await initShortLink();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    boot();
  });
} else {
  boot();
}
